import React from 'react';

export default function Navbar() {
  return (
    <nav className="bg-white shadow-lg">
     
      
    </nav>
  );
}